export const GET_GROUP_DASHBOARD_STATS_SUCCESS = 'GET_GROUP_DASHBOARD_STATS_SUCCESS';
export const GET_GROUP_DASHBOARD_STATS_FAIL = 'GET_GROUP_DASHBOARD_STATS_FAIL';
export const GROUP_DASHBOARD_STATS_API_LOADING = 'GROUP_DASHBOARD_STATS_API_LOADING';
export const GET_TIP_STATUS = 'GET_TIP_STATUS';
